module.exports = __webpack_public_path__ + "static/media/selectedLetter.ec3d972c.svg";